export const avKeys = {
  all: ['analytical-variables'] as const,
  lists: () => [...avKeys.all, 'list'] as const,
  list: (cohortVersionId: string) => [...avKeys.lists(), cohortVersionId] as const,
  details: () => [...avKeys.all, 'detail'] as const,
  detail: (avId: string) => [...avKeys.details(), avId] as const,
  profiles: () => [...avKeys.all, 'profile'] as const,
  profile: (cohortVersionId: string) => [...avKeys.profiles(), cohortVersionId] as const,
  // AV library (Story 2: list/detail for the library page)
  library: () => [...avKeys.all, 'library'] as const,
  // ``projectId`` participates in the cache key so the same AV id viewed
  // from two different projects (e.g. an org-promoted variable) doesn't
  // serve a stale entry — and so a project-scoped fetch that 404s in
  // project A doesn't poison the cache for project B (OR-6081 AC22).
  libraryDetail: (avId: string, projectId?: string) =>
    [...avKeys.library(), avId, projectId ?? ''] as const,
  // OR-6234: a detail read that may return a soft-deleted variable. Its own
  // key, deliberately outside ``library()``: the verification-result preview
  // is the only caller, and filing its answer under ``libraryDetail`` would let
  // the variable's own page render a deleted variable from cache without ever
  // asking the server (which would say not-found).
  deletedDetail: (avId: string, projectId?: string) =>
    [...avKeys.all, 'deleted-detail', avId, projectId ?? ''] as const,
  indexAvInfo: (slug: string, projectId?: string) =>
    [...avKeys.all, 'index-av-info', slug, projectId ?? ''] as const,
};

/**
 * The delete dialog's usage check — "what still uses this variable?"
 *
 * Keyed outside ``avKeys.all`` on purpose. Keep it there.
 *
 * Delete, rename and scope changes all invalidate that whole namespace. The
 * dialog is still mounted when its own delete fires, so a key inside the
 * namespace refetches usage for the row that was just deleted. The server
 * answers 404, and the dialog tells the researcher "could not check what uses
 * this" on a delete that worked.
 */
export const avUsageCheckKeys = {
  all: ['analytical-variable-usage-check'] as const,
  complete: (avId: string) => [...avUsageCheckKeys.all, 'complete', avId] as const,
};
